import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { submitVolunteerDemande } from '../services/kafalaService';
import './SaqyaWellRequest.css';
import './VolunteerRequest.css';

const emptyForm = {
  first_name: '',
  last_name: '',
  phone: '',
  ville: '',
  competence: '',
};

const VolunteerRequestTrigger = ({ className = '', children, style }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const openModal = () => {
    setOpen(true);
    setSuccess(false);
    setError('');
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess(false);
    setSaving(true);
    try {
      await submitVolunteerDemande(form);
      setForm(emptyForm);
      setSuccess(true);
    } catch (err) {
      const data = err.response?.data;
      setError(data?.message || t('volunteerForm.sendError'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <button type="button" className={className} style={style} onClick={openModal}>
        {children}
      </button>
      {open ? (
        <div className="saqya-well-modal" onClick={() => setOpen(false)} role="presentation">
          <div
            className="saqya-well-modal__dialog volunteer-request-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="volunteer-request-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="saqya-well-modal__x"
              onClick={() => setOpen(false)}
              aria-label={t('volunteerForm.close')}
            >
              <FaTimes />
            </button>
            <h3 id="volunteer-request-title">{t('volunteerForm.title')}</h3>
            <form onSubmit={onSubmit} className="saqya-well-modal__form">
              <label>
                {t('volunteerForm.lastName')}
                <input name="last_name" value={form.last_name} onChange={onChange} required />
              </label>
              <label>
                {t('volunteerForm.firstName')}
                <input name="first_name" value={form.first_name} onChange={onChange} required />
              </label>
              <label>
                {t('volunteerForm.phone')}
                <input name="phone" type="tel" value={form.phone} onChange={onChange} required dir="ltr" />
              </label>
              <label>
                {t('volunteerForm.city')}
                <input name="ville" value={form.ville} onChange={onChange} required />
              </label>
              <label>
                {t('volunteerForm.competence')}
                <textarea name="competence" value={form.competence} onChange={onChange} required rows={3} />
              </label>
              {error ? <p className="saqya-well-modal__error">{error}</p> : null}
              {success ? <p className="saqya-well-modal__success">{t('volunteerForm.success')}</p> : null}
              <button type="submit" disabled={saving}>
                {saving ? t('volunteerForm.sending') : t('volunteerForm.submit')}
              </button>
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default VolunteerRequestTrigger;
